// 커뮤니티 @멘션 토큰 순수 유틸. 저장 형태 <@user_id|DisplayName>, 표시 형태 @DisplayName.
export const MENTION_TOKEN_REGEX = /<@([^|>]+)\|([^>]+)>/g;

export const displayNameOf = (user) =>
  user.nickname || user.username || user.user_id;

// caret 왼쪽으로 스캔하여 활성 @검색어 컨텍스트를 찾는다.
// 공백/개행을 만나거나 토큰 경계('>')를 만나면 무효.
export const detectMentionQuery = (text, caret) => {
  if (text == null || caret == null) return null;
  let i = caret - 1;
  while (i >= 0) {
    const ch = text[i];
    if (ch === "@") {
      const prev = i > 0 ? text[i - 1] : "";
      if (i === 0 || /\s/.test(prev)) {
        const query = text.slice(i + 1, caret);
        if (/[\s<>|]/.test(query)) return null;
        return { query, start: i, end: caret };
      }
      return null;
    }
    if (/\s/.test(ch) || ch === ">" || ch === "<") return null;
    i -= 1;
  }
  return null;
};

// 토큰을 @DisplayName plain text로 치환 (피드 미리보기용).
export const stripMentionsToText = (text) => {
  if (!text) return text;
  return text.replace(MENTION_TOKEN_REGEX, (_m, _id, name) => `@${name}`);
};
